import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Add from '@material-ui/icons/Add';
import Pagination from '@material-ui/lab/Pagination';

import CatalogsTablePage from '../CatalogsTablePage';
import RulesBody from './RulesBody';
import BodyFilters from './RulesFilters';

// @local
import { useStyles } from '../../../../assets/styles/jss/pages/microcredentials/useStyles';

function NewRequestButton({ setRequest, setOpenModal, setModalData }) {
  const classes = useStyles();

  const onClickOption = () => {
    const newRequest = {
      workflow: [],
      form: { id: null, bundleId: '', microcredentialId: '', assignmentId: '', courseId: '', badgeId: '' },
    };
    setRequest(newRequest);
    setModalData(newRequest);
    setOpenModal(true);
  };

  return (
    <Button
      onClick={onClickOption}
      startIcon={<Add />}
      className={classes.buttonCrear}
      variant="contained"
    >
      Crear Regla
    </Button>
  );
}

const Rules = () => {
  const classes = useStyles();
  const PAGE_ONE = 1;
  const PAGE_SIZE = 10;

  const [request, setRequest] = React.useState({});
  const [page, setPage] = React.useState(PAGE_ONE);
  const [pagination, setPagination] = React.useState({ currentPage: 1, totalPages: 1 });
  const [openModal, setOpenModal] = React.useState(false);
  const [refreshFlag, setRefreshFlag] = React.useState(0);
  const [filters, setFilters] = React.useState({});
  const [searchText, setSearchText] = React.useState('');
  const [state] = React.useState({ canReadWrite: true });
  const [modalData, setModalData] = React.useState(null);
  const [refreshTable, setRefreshTable] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasRecords, setHasRecords] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [shouldHideInitial, setShouldHideInitial] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setRefreshFlag((prev) => prev + 1);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
    setPagination({ currentPage: 1, totalPages: 1 });
    setRefreshFlag((prev) => prev + 1);
  };

  return (
    <Box>
      <Box mb={3}>
        <Typography variant="h1" component="h1" gutterBottom>
          Asignación de reglas
        </Typography>
        <Typography
          variant="h6"
          component="h2"
          color="textSecondary"
          className={classes.catalogoSubtitulo}
        >
          Todas las reglas
        </Typography>
      </Box>

      <Box
        style={{
          width: '100%',
          padding: '20px',
          backgroundColor: '#1c1f24',
          borderRadius: '10px',
        }}
      >
        <Box display="flex" justifyContent="flex-end" mb={2}>
          {state.canReadWrite && (
            <NewRequestButton
              setRequest={setRequest}
              setOpenModal={setOpenModal}
              setModalData={setModalData}
            />
          )}
        </Box>

        <Divider
          style={{
            width: '100%',
            marginBottom: '50px',
            borderBottom: '1px solid #A0A9BA',
          }}
        />

        {!shouldHideInitial && (
          <BodyFilters
            onFilterChange={handleFilterChange}
            onSearchChange={setSearchText}
          />
        )}

        {!shouldHideInitial && (
          <Box display="flex" justifyContent="flex-end" mb={1}>
            <Pagination count={pagination.totalPages} page={page} onChange={handleChangePage} />
          </Box>
        )}

        <CatalogsTablePage
          key={state.canReadWrite}
          canReadWrite
          catalogType="rules"
          setRequest={setRequest}
          page={page}
          pageSize={PAGE_SIZE}
          setPagination={setPagination}
          refreshFlag={refreshFlag}
          filters={filters}
          searchText={searchText}
          refreshTrigger={refreshTable}
          onEditItem={(formData) => {
            setModalData({ form: formData });
            setOpenModal(true);
          }}
          onHasRecordsChange={(hasRecords) => {
            if (shouldHideInitial) {
              if (!hasRecords) {
                setShouldHideInitial(true);
              } else {
                setShouldHideInitial(false);
              }
            }
            setHasRecords(hasRecords);
          }}
        />

        {/* Modal */}
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          maxWidth="md"
          fullWidth
          className={classes.modalDialog}
        >
          <DialogTitle className={classes.modalTitle}>
            <Typography variant="h6" style={{ color: '#9F6FFB', fontWeight: 600 }}>
              {modalData?.form?.id ? 'Editar Regla' : 'Crear Regla'}
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.modalContent}>
            <RulesBody
              readOnly={false}
              onClose={() => setOpenModal(false)}
              onSuccess={() => {
                setOpenModal(false);
                setRefreshTable((prev) => prev + 1);
              }}
              onLoadingChange={setIsLoading}
              formData={modalData?.form}
            />
          </DialogContent>
        </Dialog>

        {/* Spinner */}
        <Backdrop className={classes.backdrop} open={isLoading}>
          <Box className={classes.spinner}>
            <CircularProgress color="inherit" size={60} />
            <Typography className={classes.spinnerText}>Guardando reglas...</Typography>
          </Box>
        </Backdrop>

        {!shouldHideInitial && (
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Pagination count={pagination.totalPages} page={page} onChange={handleChangePage} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Rules;
